/** @format */

import React, { useState, useRef } from "react";
import Select from "react-select";
import { useHistory } from "react-router";
import { toast } from "react-toastify";
import ErrorMarginServices from "../../Services/ErrorMarginServices";
import SimpleReactValidator from "simple-react-validator";

const marginTypes = [
  { value: "air", label: "Air" },
  { value: "sea", label: "SEA" },
  { value: "courier", label: "COURIER" },
  { value: "tnt", label: "LAND" },
];

export const AddErrorMargin = () => {
  const history = useHistory();

  const [, setForceUpdate] = useState("");
  const Validator = useRef(
    new SimpleReactValidator({
      autoForceUpdate: { forceUpdate: setForceUpdate },
    })
  );

  const [weightPercentage, setWeightPercentage] = useState();
  const [volumePercentage, setVolumePercentage] = useState();
  const [marginType, setMarginType] = useState();

  const submitHandler = () => {
    let postData = {
      weight_percentage: weightPercentage,
      volume_percentage: volumePercentage,
      margin_type: marginType,
    };

    let validate = Validator.current.allValid();

    if (validate) {
      ErrorMarginServices.addErrorMargindata(postData).then((result) => {
        if (result.status === true) {
          history.push("error-margin");
          toast.success(result.message);
        } else {
          toast.error(result.message);
        }
      });
    } else {
      Validator.current.showMessages();
    }
  };

  return (
    <div className="row justify-content-center">
      <div className="col-lg-6">
        <div className="card">
          <div class="d-flex mb-3 align-items-center card-header">
            <h5 class="mb-0 me-auto">Error Margin</h5>
          </div>
          <div className="card-body">
            <div className="row">
              <div className="col-6">
                <label>Margin Type</label>
              </div>
              <div className="col-6">
                <Select
                  onChange={(e) => {
                    setMarginType(e.value);
                  }}
                  options={marginTypes}
                  placeholder="Select Margin..."
                  styles={{
                    valueContainer: (provided) => ({
                      ...provided,
                      height: "calc(2.15rem + 2px)",
                      overflowY: "visible",
                    }),
                    control: (provider) => ({
                      ...provider,
                      boxShadow: "0 0 0 0px #f46a6a",
                    }),
                    placeholder: (provider) => ({
                      ...provider,
                      color: "#a0b0ca",
                    }),
                  }}
                />
                {Validator.current.message(
                  "Margin Type",
                  marginType,
                  "required",
                  { className: "text-danger" }
                )}
              </div>
            </div>

            <div className="row mt-3">
              <div className="col-6">
                <label>Error Margin On Weight(%)</label>
              </div>
              <div className="col-6">
                <input
                  type="number"
                  className="form-control"
                  placeholder="Enter Chargeable Weight"
                  name="weight_percentage"
                  onChange={(e) => setWeightPercentage(e.target.value)}
                />
                {Validator.current.message(
                  "Chargeable Weight",
                  weightPercentage,
                  "required",
                  { className: "text-danger" }
                )}
              </div>
            </div>

            <div className="row mt-3">
              <div className="col-6">
                <label>Error Margin On Volume(%)</label>
              </div>
              <div className="col-6">
                <input
                  type="number"
                  className="form-control"
                  placeholder="Enter Chargeable Volume"
                  name="volume_percentage"
                  onChange={(e) => setVolumePercentage(e.target.value)}
                />

                {Validator.current.message(
                  "Chargeable Volume",
                  volumePercentage,
                  "required",
                  { className: "text-danger" }
                )}
              </div>
            </div>
            <div className="d-flex justify-content-between">
              <button
                class="btn btn-danger d-block mt-3"
                onClick={() => history.goBack()}
              >
                Back
              </button>
              <button
                class="btn btn-primary d-block mt-3"
                onClick={() => submitHandler()}
              >
                Update
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
